module.exports = __webpack_public_path__ + "media/images/pic/certificates/top-product-0949a92ad6e54027b33b79fe86ebf148.png";